<template>
  <div v-if="relative != null">
    
    <div class="mt-12 border-t-4 pt-10 border-grey-lighter flex items-center">
      <div class="font-thin text-grey-darker text-2xl">Nearest Relative Not Living With You</div>

      <img src="/static/img/icons/icons8-info.png" 
        style="width:18px;height:18px;" 
        class="inline ml-4"
        v-tooltip.top="{ html: 'nearest-relative-tooltip' }" />

      <div id="nearest-relative-tooltip" class="p-1 leading-normal text-sm">
        This is the person whom the bank can contact if you are not available.
      </div>
    </div>

    <div class="label-line flex flex-wrap">
      <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
        <TitleSelector 
          propertyKey="contact_title"
          objectType="thirdParty"
          :value="relative.contact_title"
          :updateValue="updateValue"></TitleSelector>
      </div>

      <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
        <InputText 
          label="First name" 
          propertyKey="contact_first"
          objectType="thirdParty"
          :value="relative.contact_first"
          :updateValue="updateValue" />
      </div>

      <div class="w-full lg:w-1/3 mt-8 lg:mt-0">
        <InputText 
          label="Surname" 
          propertyKey="contact_last"
          objectType="thirdParty"
          :value="relative.contact_last"
          :updateValue="updateValue" />
      </div>
    </div>

    <div class="flex flex-wrap label-line">
      <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
        <InputText label="Relationship" 
          propertyKey="string1"
          objectType="thirdParty"
          :value="relative.string1"
          :updateValue="updateValue" />
      </div>

      <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
        <InputPhone label="Work phone number" 
          propertyKey="phone"
          objectType="thirdParty"
          :value="relative.phone"
          :updateValue="updateValue" />
      </div>

      <div class="w-full lg:w-1/3 mt-8 lg:mt-0">
        <InputPhone label="Mobile number" 
          propertyKey="phone_mobile"
          objectType="thirdParty"
          :value="relative.phone_mobile"
          :updateValue="updateValue" />
      </div>
    </div>

    <div class="flex flex-wrap label-line">
      <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
        <InputText label="Email" 
          propertyKey="email"
          objectType="thirdParty"
          :value="relative.email"
          :updateValue="updateValue" />
      </div>

      <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
        <InputText label="Address" 
          propertyKey="address"
          objectType="thirdParty"
          :value="relative.address"
          :updateValue="updateValue" />
      </div>

      <div class="w-full lg:w-1/3 mt-8 lg:mt-0">
        <InputText label="Suburb" 
          propertyKey="suburb"
          objectType="thirdParty"
          :value="relative.suburb"
          :updateValue="updateValue" />
      </div>
    </div>

    <div class="flex flex-wrap label-line">
      <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
        <InputPostcode label="Postcode" 
          propertyKey="postcode"
          objectType="thirdParty"
          :value="relative.postcode"
          :updateValue="updateValue" />
      </div>

      <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
        <StateSelector
          propertyKey="state_id"
          objectType="thirdParty"
          :value="relative.state_id"
          :updateValue="updateValue" />
      </div>

    </div>
  </div>
</template>

<script>

  import axios          from "axios"
  import TitleSelector  from '@/shared/components/form/TitleSelector'
  import InputText      from '@/shared/components/form/InputText'
  import InputPostcode  from '@/shared/components/form/InputPostcode'
  import InputPhone     from '@/shared/components/form/InputPhone'
  import StateSelector  from '@/shared/components/form/StateSelector'
  import { EventBus }   from '@/shared/event-bus';

  export default {

    components: {
      TitleSelector,
      InputText,
      InputPostcode,
      InputPhone,
      StateSelector
    },

    data () {
      return {
        relative : null,
      }
    },

    created() {
      this.getThirdParty({
        clientId: this.$route.params.clientId,
        type    : 0
      }, (thirdParty) => {
        this.relative = thirdParty
      })
    },

    methods : {
      updateValue(params) {
        this.updateThirdParty(this.relative, 0, params.key, params.value)
      }
    }
  }
</script>